"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuButtonType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
var MenuButtonType;
(function (MenuButtonType) {
    MenuButtonType["Hub"] = "hub";
    MenuButtonType["Search"] = "search";
    MenuButtonType["Tools"] = "tools";
    MenuButtonType["Library"] = "library";
    MenuButtonType["Store"] = "store";
    MenuButtonType["Settings"] = "settings";
    MenuButtonType["Tips"] = "tips-menu";
    MenuButtonType["ArMode"] = "ar-menu";
    MenuButtonType["SaveScreen"] = "save-screen";
    MenuButtonType["ExportImage"] = "export-image";
})(MenuButtonType || (exports.MenuButtonType = MenuButtonType = {}));
function BaseButton(_a) {
    var { icon, label, selected, disabled, className } = _a, handlers = __rest(_a, ["icon", "label", "selected", "disabled", "className"]);
    return ((0, jsx_runtime_1.jsxs)(Container, Object.assign({ selected: selected, className: className }, handlers, { disabled: disabled, children: [(0, jsx_runtime_1.jsx)(StyledIcon, { name: icon, selected: selected }), (0, jsx_runtime_1.jsx)(Label, { selected: selected, children: label })] })));
}
exports.default = BaseButton;
const Container = styled_components_1.default.button `
  ${({ theme }) => (0, styled_components_1.css) `
    width: ${theme.mainMenuWidth}px;
    min-height: ${theme.mainMenuWidth}px;
  `}

  margin: 0;
  padding: 15px 0;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    box-sizing: border-box;
    margin: 0 0 10px;
    padding: 5px 0;
  `)}

  color: ${({ theme, selected }) => selected ? theme.text : theme.textSecondary};
  text-align: center;

  background: transparent;
  border: none;

  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.2;
  }

  &:active,
  &:focus {
    outline: none;
  }
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 34px;
  height: 34px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    width: 25px;
    height: 25px;
  `)}
`;
const Label = styled_components_1.default.div `
  margin: 5px auto 0;

  font-weight: ${({ selected }) => (selected ? 700 : 400)};
  font-size: ${({ selected }) => (selected ? 14 : 13)}px;
  text-align: center;
  text-transform: capitalize;

  ${({ selected }) => ui_1.device.tablet((0, styled_components_1.css) `
      font-size: ${selected ? 12 : 11}px;
    `)}
`;
